import React from 'react';

// Error State Component - Shows when network is down or errors occur
export const ErrorState = ({ onRetry, message = null }) => {
  const defaultMessage = message || "Can't connect right now. Check your connection and try again.";

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 40px',
      minHeight: '400px',
      textAlign: 'center'
    }}>
      {/* Icon/Illustration */}
      <div style={{
        width: '80px',
        height: '80px',
        marginBottom: '24px',
        opacity: 0.6
      }}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', height: '100%' }}>
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
            fill="#553918"
          />
        </svg>
      </div>

      {/* Error Message */}
      <h2 style={{
        fontFamily: "'Apple Garamond', Garamond, 'Times New Roman', serif",
        fontSize: 'clamp(1.5em, 4vw, 2em)',
        color: '#312310',
        letterSpacing: '0.08em',
        fontWeight: 400,
        marginBottom: '12px'
      }}>
        Connection Error
      </h2>

      <p style={{
        fontFamily: "'Montserrat', sans-serif",
        fontSize: 'clamp(0.85em, 2.5vw, 1em)',
        color: '#553918',
        letterSpacing: '0.02em',
        fontWeight: 300,
        marginBottom: '32px',
        maxWidth: '400px',
        lineHeight: 1.6
      }}>
        {defaultMessage}
      </p>

      {/* Retry Button */}
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: 'clamp(10px, 2.5vw, 12px) clamp(20px, 5vw, 32px)',
            minHeight: '44px',
            background: '#312310',
            color: '#e6c57e',
            border: 'none',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: 'clamp(11px, 2.5vw, 13px)',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            transition: 'all 0.4s ease',
            fontWeight: 300,
            borderRadius: '4px',
            WebkitTapHighlightColor: 'transparent'
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#af731f';
            e.target.style.color = '#312310';
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#312310';
            e.target.style.color = '#e6c57e';
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorState;

